import axios from "../axiosInstance";
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import SidebarUserAgency from '../components/SidebarUserAgency';
import TopbarAgencyUser from '../components/TopBarAgencyUser';
import { errorMessage } from "../hooks/UserLogs";

export default function DetailsInvoiceAgentOfAgency() {
    const { id } = useParams();
    const [invoice, setInvoice] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [errMsg, seterrMsg] = useState("Une erreure s'est produite!!");
    const [showError, setShowErro] = useState(false);
    const bUrl = process.env.REACT_APP_B_URL;
    const navigate = useNavigate();

    const axiosInstance = axios.create({
                                    withCredentials: true,
                                  })

    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
        return new Date(dateString).toLocaleDateString(undefined, options)
    }
    const getInvoiceWalletDetails = async () => {

        const response = await axiosInstance.get(bUrl + "/invoice-startup-master/by-id?id=" + id).catch((err) => {
            if (err?.response?.status == 401 || err?.response?.status == 403) {
                seterrMsg("Vous n'étes pas autorisé à faire cette opération")
                setShowErro(true);
            } else {
                setShowErro(true);
            }

        });
        
        if (response) {

            if (response?.data?.isError) {
                const msg = errorMessage(response?.data?.code)
                seterrMsg(msg);
                setShowErro(true);
            } else {
                setInvoice(response.data.body);
            }
        }
    }
    useEffect(() => {
        if (sessionStorage.getItem("idAgency") === '' || sessionStorage.getItem("idAgency") === null) {
            //console.log("----------GO GO GO ------------")
            navigate('/agency-user-login');
        }
        getInvoiceWalletDetails();
    }, [])
    return (
        <>
            <div className="">
                <SidebarUserAgency />
                <section className="home ">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                                <p className='fw-bold'>Transactions&gt;Marchand&gt;Détails</p>
                                <div><TopbarAgencyUser /></div>
                            </div>
                            <div className="table-content mt-2 p-3">
                                <div className="d-flex justify-content-center text">
                                    <div className='col-md-3 bg-primary'>
                                    </div>
                                    {invoice?
                                        <div className='col-md-6 p-3'>
                                            {invoice.staff != null ? <>
                                                <p className='fw-bold'>Staff</p>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Prénom:</div>
                                                    <div className='col-5 fw-bold'>{invoice.staff.firstName}</div>
                                                </div>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Deuxiéme nom</div>
                                                    <div className='col-5 fw-bold'>{invoice.staff.middleName}</div>
                                                </div>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Nom</div>
                                                    <div className='col-5 fw-bold'>{invoice.staff.lastName}</div>
                                                </div>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Téléphone:</div>
                                                    <div className='col-5 fw-bold'>{invoice.staff.phone}</div>
                                                </div></> : ""}
                                            {invoice.agencyUser != null ? <>
                                                <p className='fw-bold'>Agence</p>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Code:</div>
                                                    <div className='col-5 fw-bold'>{invoice?.agencyUser?.agency?.code}</div>
                                                </div>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Prénom:</div>
                                                    <div className='col-5 fw-bold'>{invoice.agencyUser.firstName}</div>
                                                </div>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Deuxiéme nom</div>
                                                    <div className='col-5 fw-bold'>{invoice.agencyUser.middleName}</div>
                                                </div>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Nom</div>
                                                    <div className='col-5 fw-bold'>{invoice.agencyUser.lastName}</div>
                                                </div>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Téléphone:</div>
                                                    <div className='col-5 fw-bold'>{invoice.agencyUser.phone}</div>
                                                </div></> : ""}
                                            {invoice.agent != null ? <>
                                                <p className='fw-bold'>Marchand</p>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Prénom:</div>
                                                    <div className='col-5 fw-bold'>{invoice.agent.firstName}</div>
                                                </div>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Deuxiéme nom</div>
                                                    <div className='col-5 fw-bold'>{invoice.agent.middleName}</div>
                                                </div>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Nom</div>
                                                    <div className='col-5 fw-bold'>{invoice.agent.lastName}</div>
                                                </div>
                                                <div className='row mb-2 row-details'>
                                                    <div className='col-5'>Téléphone:</div>
                                                    <div className='col-5 fw-bold'>{invoice.agent.phone}</div>
                                                </div>
                                            </> : ""}
                                            <p className='fw-bold'>Transaction</p>

                                            <div className='row mb-2 row-details'>
                                                <div className='col-5'>Code:</div>
                                                <div className='col-5 fw-bold'>{invoice.invoiceCode}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-5'>Frais:</div>
                                                <div className='col-5 fw-bold'>{(invoice.amountToPaid - invoice.amountToSend).toFixed(3)}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-5'>Status:</div>
                                                <div className='col-5 fw-bold'><sapan className="p-2" style={{ background: invoice.invoiceStatus == 'P' ? "rgb(0,255,0,.3)" : invoice.invoiceStatus == 'A' ? "rgb(0,200,255,.3)" : "rgb(255,0,0,.3)" }}>{invoice.invoiceStatus == 'P' ? 'Payée' : invoice.invoiceStatus == 'A' ? 'En Attente' : 'Annulée'}</sapan></div>
                                            </div>
                                            {invoice.paymentModeObj != null ?
                                                <>
                                                    <div className='row mb-2 row-details'>
                                                        <div className='col-5'>Mode Paiement:</div>
                                                        <div className='col-5 fw-bold'>{invoice.paymentModeObj.name}</div>
                                                    </div>
                                                </>
                                                : ""}

                                            <div className='row mb-2 row-details'>
                                                <div className='col-5'>Total à payer:</div>
                                                <div className='col-5 fw-bold'>{invoice.amountToPaid ? invoice.amountToPaid.toFixed(3) : 0}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-5'>Validé le:</div>
                                                <div className='col-5 fw-bold'>{formatDate(invoice.validateAt)}</div>
                                            </div>

                                        </div> : <></>}

                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}
